import { SpanNothing } from './span-nothing';
import { ViewNothingIcon } from '@/client/assets';
import { memo } from 'react';

export const BlockNothing = memo(() => {
  return (
    <div className="w-full p-4 space-y-3 text-center">
      <ViewNothingIcon className="size-16.5 mx-auto fill-foreground/4" />
      <SpanNothing />
    </div>
  );
});
BlockNothing.displayName = 'BlockNothing';
